<template>
  <v-app class="app">
    <v-main class="px-6 mt-4 mb-4" style="min-height: 80vh">
        <router-view style="height: 100%" />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import { authApi } from '@/api'

export default {
  name: 'App',

  data: () => ({
    form: {
      username: null,
      password: null
    }
  }),

  async created() {
    await this.getAllDirectory()
  },

  methods: {
    ...mapActions('dictionaries', ['getAllDirectory'])
  }
}
</script>

<style lang="scss" scoped>
.app {
  background-color: #F4F5FA;
}
</style>
